import * as React from 'react';
import * as Redux from 'redux';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {IndigoFooter} from './IndigoFooter';
import {browserHistory} from 'react-router';
import * as Request from '../tgccRequest';
import { IndigoHeader } from './IndigoHeader';
import {Message} from '../Components/Message';


const wrapperStyle: React.CSSProperties = {
    fontFamily: 'CenturyGothic',
    height: 'auto',
    backgroundColor:'#F7F5F0'
}

const contentStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column'
}

const woStyle: React.CSSProperties = {
    fontSize: '22px',
    letterSpacing: '3px',
    fontWeight: 'lighter',
    textTransform: 'uppercase',
    color: 'rgba(88,88,88,0.8)',
    paddingTop:'10px',
    fontFamily:'AveriaSerifBold'
}

const statusStyle: React.CSSProperties = {
    fontSize: '18px',
    fontWeight: 100,
    textTransform: 'uppercase',
    marginBottom: '10px',
    fontFamily:'AveriaSerifBold',
    color: 'rgba(88,88,88,0.7)',
    '@media(max-width:414px)': {
        fontSize:'16px'
    },
    '@media(max-width:375px)': {
        fontSize:'15px'
    },
    '@media(max-width:320px)': {
        fontSize:'12px'
    }
    
}
const imgStyle: React.CSSProperties = {
    alignSelf: 'center',
    width: 'auto',
    height: '600px',
    maxWidth: '80%',
    maxHeight: '750px',
    margin: '25px auto',
    boxShadow: Tgcc.Styles.boxShadow,
}

const btnStyle: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Reitam',
    fontSize: '18px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    backgroundColor: '#E27558',
    padding: '5px 40px',
    cursor: 'pointer',
    maxWidth: '65%', 
    margin: '5px 20px',
}
const btnContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop:'20px'
}
const btnText: React.CSSProperties = {
    margin: '5px 10px',
    textTransform: 'uppercase',
    color: 'white',
    fontFamily: 'Reitam',
    fontSize: '12px',
    letterSpacing: '3px',
    padding: '0',
    textAlign: 'center',
    '@media (max-width:414px)': { fontSize:'10px' }
}
const reviewTxt: React.CSSProperties = {
    textAlign:'center',
    color:'green',
    fontSize:'22px'
}

const dashHdrLineR: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginRight:'10px'
}

const dashHdrLineL: CSSProperties = {
    width:'180px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block',
    marginBottom:'8px',
    marginLeft:'5px'
}

const dashText: React.CSSProperties = {
    display:'inline-block',
    letterSpacing:'0.3em',
    fontSize:'26px',
    fontFamily:'Reitam',
    color:'#686868'
}
const createAcc: React.CSSProperties ={
    textAlign:'center',
    marginTop:'50px'
}

const statStyle: React.CSSProperties = {
    color:'#E27558',
    fontFamily:'AveriaSerifBold'
}

const containerStyle: React.CSSProperties = {
    backgroundColor:'#E9E6E6',
    width:'775px',
    margin:'auto',
    textAlign:'center',
    borderRadius:'20px'
}
const imgContainer: React.CSSProperties = {
    width:'700px',
    backgroundColor:'white',
    margin:'auto'
}
const notLoggedIn: React.CSSProperties = {
    textAlign:'center',
    fontSize:'20px',
    fontFamily:'AveriaSerifLight',
    position:'absolute',
    top:'0px',
    left:'50%',
    width: '500px',
    height:'50px',
    marginLeft:'-250px',
    zIndex:2,
    lineHeight:'48px',
    backgroundColor:'#E9E6E6',
    borderBottomLeftRadius:'15px',
    borderBottomRightRadius:'15px'
}
const proofText: React.CSSProperties = {
    fontFamily:'AveriaSerifLight',
    color:'#636261',
    width:'75%',
    margin:'auto'
}
const fourPoints: React.CSSProperties = {
    display:'flex',
    flexWrap:'wrap',
    flexDirection:'row'
}
const pointBox: React.CSSProperties = {
    display:'flex',
    flexDirection:'column',
    flexBasis: "calc(50% - 40px)",
    margin:'20px'
}

const disableBtn: React.CSSProperties = {
    alignSelf: 'center',
    textAlign: 'center',
    fontFamily: 'Reitam',
    fontSize: '18px',
    textTransform: 'uppercase',
    letterSpacing: '10px',
    color: 'white',
    backgroundColor: '#B5B5B4',
    padding: '5px 40px',
    maxWidth: '65%', 
    margin: '5px 20px',
    cursor:'not-allowed'
}
const approveDiv:React.CSSProperties = {
    display:'flex'
}
const descText: React.CSSProperties = {
    fontFamily:'CenturyGothic'
}
const checkText: React.CSSProperties = {
    fontFamily:'CenturyGothic',
    color:'#E27558',
}

class _IndigoProofView extends React.Component<Tgcc.BaseProps, any>{
    state = { 
        proof: null,
        error: null,
        confirmProof:false,
        agree:false,
        finished:false,
        isSubmitting: false,
    };


    init = (login: Tgcc.LoginData) => {
        if(login){
            var proofId = this.props.location.query.proofId;
            var doRead = () => {Request.getProof(login, proofId, this.proofLoaded, this.loadError) };
            if(Object.keys(this.props.location.query).indexOf("Approve") > -1){
            } else if(Object.keys(this.props.location.query).indexOf("Cancel") > -1){
                Request.cancelProof(login, proofId, doRead, doRead);
            } else {
                doRead();
            }
        }
    }

    componentWillMount(){
        if(this.props.state.LoginData)
            this.init(this.props.state.LoginData);
        else
            Tgcc.LoginUser( this.props.dispatch);
    }

    componentDidMount(){
        var el = document.getElementById('proofReview');
        el.scrollIntoView(false);
    }

    componentWillReceiveProps(props: any){
        if(props.state.LoginData)
            this.init(props.state.LoginData);
    }

    proofLoaded = (proof: Tgcc.Proof) => {
        this.setState({proof: proof});
    }

    loadError = (err: any) => {
        console.log("error loading proof: ", err);
    }

    onError = (evt: React.SyntheticEvent<HTMLImageElement>) => {
        evt.currentTarget.src = Tgcc.Styles.missingProofImageSrc;
    }

    canReviseProof = (proof: Tgcc.Proof) => {
        if(proof && proof.status){
            switch(proof.status.toString().toUpperCase()){
                case 'EMAILED':
                case 'MISSING':
                case 'M-PROOF':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    canApproveProof = (proof: Tgcc.Proof) => {
        if(proof && proof.status){
            switch(proof.status.toString().toUpperCase()){
                case 'EMAILED':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    reviseProof = () => {
       browserHistory.push(Tgcc.Routes.IndigoProofRevise(this.state.proof.proofId));
       this.setState({confirmProof:false});
    }

    approvalComplete = () => {
        try {
            this.setState({ isSubmitting: false });
            browserHistory.push(Tgcc.Routes.IndigoDashboard);
        } catch (error) {
            console.error("Error in approvalComplete:", error);
            this.setState({ isSubmitting: false });
            // Fallback: navigate to dashboard if there's an error
            browserHistory.push(Tgcc.Routes.IndigoDashboard);
        }
    }
    proofApprove = () => {
        this.setState({finished: true, isSubmitting: false});
    }
    getThankYou = () => {
        return <Message 
                    Title="Thank You!"         
                    UseTitleScript={true}
                    Message1="You have successfully approved your proof. Your account manager will be in contact with you in regards to final size breakdown and payment information."
                    Message2={"Proof Number: " + this.state.proof.proofId}
                    onContinue={this.approvalComplete}
                 />
    }
    approvalFailed = (err: any) => {
        this.setState({error: err, isSubmitting: false});
    }
    approveProof = () => {
        // Prevent multiple submissions
        if (this.state.isSubmitting) {
            return;
        }
        
        try {
            // Validate required data exists
            if (!this.props.state.LoginData) {
                this.approvalFailed("You must be logged in to approve a proof.");
                return;
            }
            
            if (!this.state.proof || !this.state.proof.proofId) {
                this.approvalFailed("Proof information is missing. Please refresh the page and try again.");
                return;
            }
            
            // Set submitting state
            this.setState({ isSubmitting: true, error: null });
            
            Request.approveIndigoProof(this.props.state.LoginData, this.state.proof.proofId, this.proofApprove, this.approvalFailed);
        } catch (error) {
            console.error("Error in approveProof:", error);
            this.setState({ isSubmitting: false });
            this.approvalFailed("An unexpected error occurred. Please try again or contact support.");
        }
    }

    viewRoster = (evt: React.MouseEvent<HTMLDivElement>) => {
        evt.stopPropagation();
        browserHistory.push(Tgcc.Routes.ProofRoster(this.props.location.query.proofId));
    }
    doTracking = (evt: React.MouseEvent<HTMLDivElement>, tracking: string) =>{
        evt.stopPropagation();
        window.open("https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=" + tracking, "tgcctracking");
    }
    getDashHeader(){
        return (
            <div style={createAcc}>
                <div style={dashHdrLineR}></div>
                <h1 style={dashText}>PROOF REVIEW</h1>
                <div style={dashHdrLineL}></div>

            </div>
        )
    }
    notLoggedin () {
        if(!this.props.state.LoginData){
            return (
                <div>
                    <div style={notLoggedIn} className='pVNotLoggedIn'>Please log in to view your proof.</div>
                </div>
            )}
    }
    confirmApproval =() => {
        this.setState({confirmProof:true});
        this.props.dispatch({type: Tgcc.StateAction.DialogAction, payload: {action: Tgcc.DialogAction.ConfirmApproval, payload: {Message1: "Please read the provided information and confirm that you understand and agree."}}});
    }
    confirmProof (){
        if(this.state.confirmProof){
            return (
                <div style={proofText}>
                    <h3>PLEASE REVIEW THE INFORMATION BELOW TO APPROVE DESIGN AND ORDER</h3>
                    <h2>WE USE PERMANENT INK!</h2>
                    <div style={descText}>Check Spelling, Color, Size and Placement. Please look over EVERY detail of the proof before you give us the green light. If there's a specific color you're looking for let us know beforehand. Every computer screen is different, and we can't guarantee that the color you're looking at will look exactly the same as what you'll get.</div>
                    <h2>YOU CAN'T STOP A MOVING TRAIN</h2>
                    <div style={descText}>Everyone in our shop gets to work as soon as your order is placed. This is so you get your order FAST! Unfortunately, it also means that any changes after approval are costly and time consuming. If you make a change after the order is submitted, it may cost you a $50 change fee and your order will be delayed.</div>
                    <h2>WE'RE HUMAN!</h2>
                    <div style={descText}>Because of the many variables of custom printing, mistakes do happen. Like most in this industry, we reserve the right to ship a variance of 3-5% under the quantities ordered. This doesn't happen often, but while we promise to do our very best to get you exactly what you ordered, we highly recommend that you include extras to cover for the possibility of missing pieces, new orders, or wrong sizes ordered. You will only be billed for what you received.</div>
                    <h2>THE SAME RULES APPLY TO REORDERS.</h2>
                    <div style={descText}>We don't print less than our minimum, it's usually most cost effective to add a few extras to first order rather than planning on a reorder.</div>
                    <h2>FEDEX IS AWESOME</h2>
                    <div style={descText}>Once the order is picked up by a FedEx driver there is little we can do to redirect or change shipping methods. Make sure you're giving a good shipping address when you order.</div>
                    <h2>WE LOVE HAPPY CUSTOMERS!</h2>
                    <div style={descText}>Happy customers don't like surprises, so we make the process as seamless as possible and do our very best to keep you in the know! Here's how:</div>
                    <div style={fourPoints} className='fourPoints'>
                        <div style={pointBox}>
                            <div>1.</div>
                            <div style={descText}>Every order is counted by hand to check that the sizes, styles, and colors are right and to keep any manufacturer defects out of the mix.</div>
                        </div>
                        <div style={pointBox}>
                            <div>2.</div>
                            <div style={descText}>Finished orders are counted and checked again when they're packed to make sure all sizes are there, and that the design looks great.</div>
                        </div>
                        <div style={pointBox}>
                            <div>3.</div>
                            <div style={descText}>We are an open book. If a charge happens last minute or your order is going to take longer than we expected, you will be told right away so that you can be a part of the solution.</div>
                        </div>
                        <div style={pointBox}>
                            <div>4.</div>
                            <div style={descText}>If we catch a problem, we'll pull out all the stops to fix it without messing with your in hands date.</div>                       
                        </div>
                    </div>
                    <h2>WE TAKE PRIDE IN OUR COMMITMENT TO THE CUSTOMER EXPERIENCE AND THE QUALITY OF OUR FINAL PRODUCT.</h2>
                    <h2>PLEASE GIVE US A CALL IF YOU HAVE ANY QUESTIONS!</h2>
                    <div>
                        <input type='checkbox' value="yes" onChange={this.readChanged}/>
                        <label htmlFor="checkbox" style={checkText}>***I understand and agree to the information above.***</label>
                    </div>
                </div>

            )

        }
    }
    back = () => {
        this.setState({confirmProof:false});
        this.setState({agree:false});
        document.getElementById("approveBtn").style["display"] = "block";
        var el = document.getElementById('proofReview');
        el.scrollIntoView(false);

    }
    readChanged = (evt: React.SyntheticEvent<HTMLInputElement>) => {
        console.log(evt.currentTarget.checked)
        if (evt.currentTarget.checked){
            this.setState({agree:true});
        }
        else {
            this.setState({agree:false})
        }
    }
    paymentBtn() {
        const isDisabled = this.state.isSubmitting;
        const buttonStyle = isDisabled ? disableBtn : btnStyle;
        
        if(this.state.agree){
            return(<div style={approveDiv}>
                    <div style={buttonStyle} onClick={isDisabled ? undefined : (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.approveProof();
                    }} className='confirmDisable'>
                        <div style={btnText}>{this.state.isSubmitting ? "Submitting..." : "Approve Design & Order"}</div>
                    </div>
                    <div style={btnStyle} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (!isDisabled) {
                            this.back();
                        }
                    }}>
                            <div style={btnText}>BACK</div>
                    </div>
                </div>)
        }
        if(this.state.confirmProof && !this.state.agree) {
            return(<div style={approveDiv}>
                    <div style={disableBtn} className='confirmDisable'>
                        <div style={btnText}>Approve Design & Order</div>
                    </div>
                    <div style={btnStyle} onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.back();
                    }}>
                        <div style={btnText}>BACK</div>
                    </div>
                </div>)
        }
       
    }

    render(){
        var proof: Tgcc.Proof = this.state.proof || new Tgcc.Proof;
        var imgPath = proof.status != "REVIEW" ? Tgcc.getProofPath(proof.proofId) : Tgcc.Styles.missingProofImageSrc;
        var error = this.state.error ? <div style={Tgcc.Styles.error}>{this.state.error}</div>:null;
        var canViewRoster = (proof && (proof.rosterCodes && proof.rosterCodes.length));

        var changeBtn = this.canReviseProof(proof) && !this.state.confirmProof ? <div className="hoverBorder" style={btnStyle} id="chgBtn" onClick={this.reviseProof}><div style={btnText}>make changes</div></div> : null;
        var approveBtn = this.canApproveProof(proof) && !this.state.confirmProof ? <div className="hoverBorder" style={btnStyle} onClick={this.confirmApproval} id="approveBtn"><div style={btnText}>Approve Design</div></div> : null;

        var viewRosterBtn = proof && canViewRoster ? <div className="hoverBorder" style={btnStyle} onClick={this.viewRoster}><div style={btnText}>view roster</div></div> : null;
        
        var text = proof.status == "REVIEW" ? <div style={reviewTxt}>Your artwork is being reviewed by our art staff.</div>: null;
        var trackStyle = Object.assign({}, statusStyle, {textDecoration: 'underline', cursor: 'pointer'});
        var tracking = proof && proof.tracking ? 
            <div style={trackStyle} onClick={ (evt) => this.doTracking(evt, proof.tracking)}>Tracking: {proof.tracking}</div> 
            : null;
        var thankYou = this.state.finished ? this.getThankYou():null;
        return (
                <div style={wrapperStyle}>
                    {this.notLoggedin()}
                    <div style={contentStyle}>
                    <IndigoHeader />
                        <div id="proofReview"></div>
                        {this.getDashHeader()}
                        <div style={containerStyle} className="proofViewBox">
                            <div style={woStyle}>{proof.proofId}</div>
                            <div style={statusStyle}>Order Status: <span style={statStyle}>{proof.status}</span></div>
                            {text}
                            {tracking}
                            <div style={imgContainer} className="proofViewCont">
                                <img style={imgStyle} src={imgPath} onError={this.onError} className="proofImg"/>
                                {error}
                                {this.confirmProof()}
                            </div>                          
                                <div style={btnContainerStyle} id="btnCont">
                                    {changeBtn}
                                    {approveBtn}
                                    {this.paymentBtn()}
                                    {viewRosterBtn}

                            </div>
                            {thankYou}
                        </div>
                        <IndigoFooter state={this.props.state} />
                    </div>
                 </div>
        )
    }
}


const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state  }
};

export var IndigoProofView = connect(mapStateToProps)(Radium(_IndigoProofView));